import React, { useEffect, useState } from "react";
import { NavLink, withRouter } from "react-router-dom"; // v4/v5 compatible
import BookRecommendation from "../extra-materials/BookRecommendation";
import "./SideBar.css";

// Optional AdSense slot (replace ids or remove if not using AdSense yet)
function AdSlot({ adSlot = "5201219465" }) {
  useEffect(() => {
    try {
      if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
        window.adsbygoogle.push({});
      }
    } catch {}
  }, []);

  return (
    <div className="my-3">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-9033879555371063"
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

const CATEGORIES = [
  { label: "Java", to: "/java" },
  { label: "Java 8", to: "/java8features" },
  { label: "Spring", to: "/spring" },
  { label: "Hibernate", to: "/hibernate" },
  { label: "React JS", to: "/react" },
  { label: "SQL", to: "/sql" },
  { label: "MongoDB", to: "/mongoDB" },
  { label: "JavaScript", to: "/javascript" },
  { label: "Kafka", to: "/kafka" },
  { label: "Design Patterns", to: "/designPatterns" },
  { label: "Microservices", to: "/microservices" },
  { label: "REST API", to: "/restAPI" },
  { label: "Behavioral", to: "/behavioral" }
];

function QnASideBarRight({ className = "", style = {}, history }) {
  const [query, setQuery] = useState("");

  const onSearch = (e) => {
    e.preventDefault();
    const q = query.trim();
    if (q) history.push(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <aside
      className={`sidebar-right ${className}`}
      style={{ position: "sticky", top: "1rem", alignSelf: "flex-start", ...style }}
      aria-label="Right Sidebar"
    >
      {/* Search */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-3">Search</h2>
          <form className="d-flex" onSubmit={onSearch} role="search" aria-label="Sidebar search">
            <input
              type="search"
              className="form-control form-control-sm me-2"
              placeholder="Search topics…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              aria-label="Search topics"
            />
            <button className="btn btn-primary btn-sm" type="submit">Go</button>
          </form>
        </div>
      </div>

      {/* Categories */}
      <nav className="card shadow-sm border-0 mb-3" aria-labelledby="sidebar-topics">
        <div className="card-body p-0">
          <div className="px-3 pt-3"><h2 id="sidebar-topics" className="h6 text-uppercase text-muted m-0">Interview Topics</h2></div>
          <ul className="list-group list-group-flush">
            {CATEGORIES.map((c) => (
              <li className="list-group-item d-flex justify-content-between align-items-center" key={c.to}>
                {/* v4/v5 NavLink API uses activeClassName */}
                <NavLink
                  exact
                  to={c.to}
                  className="text-decoration-none text-body"
                  activeClassName="fw-semibold text-primary"
                  aria-label={`Go to ${c.label}`}
                >
                  {c.label}
                </NavLink>
                <span className="badge bg-light text-muted border">Q&A</span>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Quick Actions */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-3">Quick Actions</h2>
          <div className="d-grid gap-2">
            <NavLink exact className="btn btn-outline-primary btn-sm" to="/systemDesign">Start System Design</NavLink>
            <NavLink exact className="btn btn-outline-secondary btn-sm" to="/codingRound">Practice Coding</NavLink>
            <NavLink exact className="btn btn-outline-success btn-sm" to="/badges">Earn a Certificate</NavLink>
          </div>
        </div>
      </div>

      {/* Book Recommendation (wrapped in a card) */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-3">Recommended Reading</h2>
          <BookRecommendation />
        </div>
      </div>

      {/* Optional Ad slot */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-3">Sponsored</h2>
          <AdSlot adSlot="5201219465" />
          <div className="small text-muted">Ads help keep content free.</div>
        </div>
      </div>

      {/* Contact */}
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-2">Need help?</h2>
          <p className="small text-muted mb-3">
            Have a topic request or correction? We’d love to hear from you.
          </p>
          <NavLink exact to="/contactUs" className="btn btn-dark btn-sm w-100">Contact Us</NavLink>
        </div>
      </div>
    </aside>
  );
}

export default withRouter(QnASideBarRight);
